import { render, staticRenderFns } from "./ModalLink.vue?vue&type=template&id=6fa4e2ca&"
import script from "./ModalLink.vue?vue&type=script&lang=js&"
export * from "./ModalLink.vue?vue&type=script&lang=js&"
import style0 from "./ModalLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports